import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { Provider } from 'react-redux';
import { store, persistor } from './stateManager';
import { PersistGate } from 'redux-persist/integration/react';
import { Toast } from './helpers/commonUi/Toast'
// import { HashRouter } from 'react-router-dom';
import "firebase/auth";
import { DndProvider } from 'react-dnd';
import HTML5Backend from 'react-dnd-html5-backend';

import "./assets/WorkSans_Fonts/WorkSans-ExtraLight.ttf"
import "./assets/WorkSans_Fonts/WorkSans-Thin.ttf"
import "./assets/WorkSans_Fonts/WorkSans-Light.ttf"
import "./assets/WorkSans_Fonts/WorkSans-Regular.ttf"
import "./assets/WorkSans_Fonts/WorkSans-Medium.ttf"
import "./assets/WorkSans_Fonts/WorkSans-SemiBold.ttf"
import "./assets/WorkSans_Fonts/WorkSans-Bold.ttf"
import "./assets/WorkSans_Fonts/WorkSans-ExtraBold.ttf"
import "./assets/WorkSans_Fonts/WorkSans-Black.ttf"

declare var window: any;


window["React"] = React;
window["ReactDOM"] = ReactDOM;

/**
 * index documents
 */

// Set log level
if(!sessionStorage.getItem("logLevel")) {
    sessionStorage.setItem("logLevel", "0");
} 

ReactDOM.render(
    <Provider store={store}>
        <PersistGate persistor={persistor}>
            <DndProvider backend={HTML5Backend}>
                <App />
            </DndProvider>
            <Toast />
        </PersistGate>
    </Provider>, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
